import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d22912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "puzzle-modal-video-player" }
const _hoisted_2 = {
  key: 0,
  class: "video"
}

import Video from '@/components/Video.vue'
import { useStorePuzzle } from '@/stores/puzzle'
import Modal from '@/components/Modal.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    dataVideoId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  dataVideoId: string | null
}



const puzzleModalVideoPlayer = ref<InstanceType<typeof Modal> | null>(null)

const puzzleStore = useStorePuzzle()

function quitVideo() {
  puzzleStore.setCurrentVideoId(null)
}

async function show() {
  puzzleModalVideoPlayer.value?.show()
}

expose({
  show,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "puzzleModalVideoPlayer",
    ref: puzzleModalVideoPlayer,
    title: _ctx.$t('puzzle.modalVideoPlayer.title'),
    "validate-btn-text": _ctx.$t('puzzle.quitTheVideo'),
    onOnValidateClick: quitVideo,
    onOnCancelClick: quitVideo
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.dataVideoId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(Video, {
                "data-video-id": props.dataVideoId
              }, null, 8, ["data-video-id"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "validate-btn-text"]))
}
}

})